import { styled as t } from "@lokalise/styled";
import { typography as i, value as r, spacing as o } from "../../utils/theme/index.js";
const e = t.div`
	${i("body.tiny.default")}

	color: ${r("color.background.action.danger.default")};
	display: grid;
	gap: ${o(1)};
	grid-template-columns: min-content auto;
	align-items: center;
`, l = t.div`
	display: grid;
	gap: ${o(1)};
`, d = t.div`
	align-self: flex-start;
	font-size: 16px;
	display: flex;
	align-items: center;
`;
export {
  e as Error,
  d as IconContainer,
  l as MultiErrorContainer
};
//# sourceMappingURL=styles.js.map
